var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 8,
    viewBox: "0 0 131 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.999 6.5965C131.164 8.72287 98.5199 3.66847 58.6341 3.66847C30.4062 3.66847 12.0815 6.48459 4.35523 7.06931C1.64995 7.27404 1.08738 5.43611 3.69257 4.67886C10.8315 2.60376 28.534 -0.242019 58.6341 0.126178C97.9583 0.126178 130.999 4.09659 130.999 6.5965Z",
    fill: "#FEB853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.b64394a12e4b23d01a89c587c81d1bfb.svg";
export { ForwardRef as ReactComponent };